import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Switch from "react-switch";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";
import { ExportToCsv } from 'export-to-csv';
//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { MdDelete } from 'react-icons/md';
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { FinanceContext } from "../../../../../contexts/Finance";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import DataTable from "../../../../common/DataTable";

const IngredientItem = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  const { supplierForSearch, getSupplier } = useContext(UserContext);
  const { cao3Active, getCoaL3 } = useContext(FinanceContext);
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {

    //brand
    brandStatus,
    setBrandPagination,

    //item
    ingredientItemList,
    setIngredientItemList,
    setPaginatedIngredientItem,
    setIngredientItemForSearch,
    setIngredientItemNonPurchase,
    setIngredientItemStock,
    ingredientItemListForSearch,
    setIngredientItemListForSearch,

    //group
    getIngredientGroup,
    ingredientGroupForSearch,

    //unit
    ingredientUnitForSearch,
    getIngredientUnit,
    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  // States hook here
   // upload csv
   const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: 'ingredient-item',
  };
  const csvExporter = new ExportToCsv(options);
  const [uploadCsv,setUploadCsv] = useState(null);
  //new ingredient group
  let [newIngredientItem, setNewIngredientItem] = useState({
    id: null,
    name: "",
    supplier: null,
    brand: null,
    default_unit: null,
    base_unit : null,
    base_qty : 1,
    default_qty : 0,
    sort_order: "",
    coa_cogs: null,
    coa_stock: null,
    coa_revenue: null,
    itemGroup: null,
    edit: false,
    status: true,
    is_non_purchasable: false,
    allow_multi_quantity: 1,
    editSlug: null,
    uploading: false,
    price: 0,
    reorderQty: 0,
    sell_price: 0,
    item_code: ""
  });

  //search result
  let [searchedIngredientGroup, setSearchedIngredientGroup] = useState({
    list: null,
    searched: false,
  });

  const [filteredIngUnits, setFilteredIngUnits] = useState(null)

  useEffect(() => {
    const data = ingredientUnitForSearch?.filter(item => item.status === 1)
    setFilteredIngUnits(data)
  }, [ingredientUnitForSearch])
  
  //useEffect == componentDidMount
  useEffect(() => {
    setPaginatedIngredientItem(1);
    if(!ingredientUnitForSearch){
      getIngredientUnit();  
    }
    if(!ingredientGroupForSearch){
      getIngredientGroup();
    }
    if(!supplierForSearch){
      getSupplier()
    }
    if(!brandStatus){
      setBrandPagination(1)
    }
    if(!cao3Active){
      getCoaL3();
    }
  }, []);

  //handle Set item group hook
  const handleSetItemGroup = (itemGroup) => {
    setNewIngredientItem({ ...newIngredientItem, itemGroup });
  };

  //handle Set hook
  const handleSetSelect = (name, value) => {
    setNewIngredientItem({ ...newIngredientItem, [name]: value});
  };

  const handleSetItemBrand = (brand) => {
    setNewIngredientItem({ ...newIngredientItem, brand });
  };

  const handleSetIngredientUnit = (unit) => {
    setNewIngredientItem({ ...newIngredientItem, default_unit: unit });
  }

  const handleSetSupplier = async(supplier) => {
    setNewIngredientItem({ ...newIngredientItem, supplier });
  }

  const handleSetIngredientBaseUnit = (unit) => {
    setNewIngredientItem({ ...newIngredientItem, base_unit : unit });
  }

  //set name, phn no hook
  const handleSetNewIngredientGroup = (e) => {
    setNewIngredientItem({
      ...newIngredientItem,
      [e.target.name]: e.target.value,
    });
  };
 
  const validateUnitQuantities = () => {
    if (newIngredientItem.default_unit?.id === newIngredientItem.base_unit?.id) {
      if (Number(newIngredientItem.default_qty) !== Number(newIngredientItem.base_qty)) {
        toast.error(`${_t(t("Quantities must be the same if units are the same"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return false;
      }
    }
    return true;
  };

  //Save New customer
  const handleSaveNewIngredientGroup = (e) => {
    e.preventDefault();

    if(newIngredientItem.default_qty === "" || newIngredientItem.default_qty == "0"){
      toast.error(`${_t(t("Default qty will be greater than 0"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }

    if(newIngredientItem.base_unit === null || newIngredientItem.default_unit === null){
      toast.error(`${_t(t("Please select base/default unit"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }

    if (!validateUnitQuantities()) return false;

    if (newIngredientItem.itemGroup !== null) {
      setNewIngredientItem({
        ...newIngredientItem,
        uploading: true,
      });
      
      const supplier = newIngredientItem.supplier?.length ? (newIngredientItem.supplier.map((item)=>item.id)) : ""
      const customerUrl = BASE_URL + `/settings/new-ingredient_item`;
      let formData = new FormData();
      formData.append("name", newIngredientItem.name);
      formData.append("supplier_ids", supplier);
      formData.append("item_code", newIngredientItem.item_code === "" ? 0 : newIngredientItem.item_code);
      formData.append("group_id", newIngredientItem.itemGroup.id);
      formData.append("brand_id", newIngredientItem.brand?.id ?? "");
      formData.append("unit_id", newIngredientItem.base_unit.id);
      formData.append("unit_code", newIngredientItem.base_unit.code);
      formData.append("default_unit_id", newIngredientItem.default_unit.id);
      formData.append("base_qty", newIngredientItem.base_qty);
      formData.append("default_qty", newIngredientItem.default_qty);
      formData.append("sort_order", newIngredientItem.sort_order);
      formData.append("allow_multi_quantity", (newIngredientItem.allow_multi_quantity));
      formData.append("is_non_purchasable", (newIngredientItem.is_non_purchasable == 1 || newIngredientItem.is_non_purchasable === true) ? 1 : 0);
      formData.append("price", newIngredientItem.price);
      formData.append("sell_price", newIngredientItem.sell_price || 0);
      formData.append("re_order_qty", newIngredientItem.reorderQty);
      formData.append("status", newIngredientItem.status === true ? 1 : 0);
      formData.append("inventory_account_id", newIngredientItem.coa_stock?.id ?? "");
      formData.append("inventory_account_name", newIngredientItem.coa_stock?.level3_name ?? "");
      formData.append("revenue_account_id", newIngredientItem.coa_revenue?.id ?? "");
      formData.append("revenue_account_name", newIngredientItem.coa_revenue?.level3_name ?? "");
      formData.append("cogs_account_id", newIngredientItem.coa_cogs?.id ?? "");
      formData.append("cogs_account_name", newIngredientItem.coa_cogs?.level3_name ?? "");

      return axios
        .post(customerUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setNewIngredientItem({
            id: null,
            name: "",
            brand_id: null,
            supplier: null,
            default_unit: null,
            base_unit : null,
            base_qty : 1,
            coa_cogs: null,
            coa_stock: null,
            coa_revenue: null,
            default_qty:"",
            sort_order: "",
            itemGroup: null,
            edit: false,
            allow_multi_quantity: 1,
            is_non_purchasable: false,
            status: true,
            editSlug: null,
            uploading: false,
            sell_price: 0,
          });
          setIngredientItemList(res.data[0]);
          setIngredientItemListForSearch(res.data[1])
          setIngredientItemStock(res.data[2])
          setIngredientItemForSearch(res.data[3]);
          setIngredientItemNonPurchase(res.data[4]);
          setLoading(false);
          toast.success(`${_t(t("Ingredient item has been added"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          document.getElementById('close-btn').click();
        })
        .catch((error) => {
          if(error.response.data?.errors?.name){
            toast.error(`${_t(t(error.response.data.errors.name[0]))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
          setLoading(false);
          setNewIngredientItem({
            ...newIngredientItem,
            uploading: false,
          });
        });
    } else {
      toast.error(`${_t(t("Please select a group"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //set edit true & values
  const handleSetEdit = (id) => {
    let ingredientItem = ingredientItemListForSearch.find((item) => {
      return item.id === id;
    });

    let ingredientGroup = ingredientGroupForSearch.find((grp) => {
      return grp.id === parseInt(ingredientItem.ingredient_group_id);
    });

    let brand = null;
    if(ingredientItem?.brand_id){
      brand = brandStatus && brandStatus.find((bnd) => {
        return bnd.id === parseInt(ingredientItem.brand_id);
      });
    }

    let unit = filteredIngUnits.find((unt) => {
      return unt.id === parseInt(ingredientItem.unit_id)
    })
    let defaultUnit = filteredIngUnits.find((unt) => {
      return unt.id === parseInt(ingredientItem.default_unit_id)
    });

    let coaCogs = ingredientItem.cogs_account_id ? {
      id: ingredientItem.cogs_account_id,
      level3_name: ingredientItem.cogs_account_name, 
    } : null;

    let coaStock = ingredientItem.inventory_account_id ? {
      id: ingredientItem.inventory_account_id,
      level3_name: ingredientItem.inventory_account_name, 
    } : null;

    let coaRevenue = ingredientItem.revenue_account_id ? {
      id: ingredientItem.revenue_account_id,
      level3_name: ingredientItem.revenue_account_name,
    } : null;

    setNewIngredientItem({
      ...newIngredientItem,
      name: ingredientItem.name,
      supplier: ingredientItem.suppliers?.length ? ingredientItem.suppliers : "",
      default_unit: defaultUnit,
      brand: brand,
      base_unit : unit,
      coa_cogs: coaCogs,
      coa_stock: coaStock,
      coa_revenue: coaRevenue,
      base_qty : ingredientItem.base_qty ? parseFloat(ingredientItem.base_qty).toFixed(2) : 1,
      default_qty: parseFloat(ingredientItem.default_qty).toFixed(2),
      sort_order: ingredientItem?.sort_order ?? "",
      itemGroup: ingredientGroup,
      id: ingredientItem.id,
      editSlug: ingredientItem.slug,
      item_code: ingredientItem.item_code,
      price: ingredientItem.price,
      sell_price: ingredientItem?.sell_price ?? 0,
      allow_multi_quantity: ingredientItem.allow_multi_quantity,
      is_non_purchasable: ingredientItem.is_non_purchasable == 1 || ingredientItem.is_non_purchasable === true || ingredientItem.is_non_purchasable === "1",
      reorderQty: ingredientItem.re_order_qty,
      status: ingredientItem.status == 1,
      edit: true,
    });
  };

  //update customer
  const handleUpdateIngredientGroup = async (e) => {
    e.preventDefault();
    if(newIngredientItem.default_qty === "" || newIngredientItem.default_qty == "0"){
      toast.error(`${_t(t("Default qty will be greater than 0"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }

    if(newIngredientItem.base_unit === null || newIngredientItem.default_unit === null){
      toast.error(`${_t(t("Please select base/default unit"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }

    if (!validateUnitQuantities()) return false;

    if (newIngredientItem.itemGroup !== null) {
      setNewIngredientItem({
        ...newIngredientItem,
        uploading: true,
      });
      const supplier = newIngredientItem.supplier?.length ? (newIngredientItem.supplier.map((item)=>item.id)) : "";
      const customerUrl = BASE_URL + `/settings/update-ingredient_item`;
      let formData = new FormData();
      formData.append("id", newIngredientItem.id);
      formData.append("name", newIngredientItem.name);
      formData.append("brand_id", newIngredientItem.brand?.id ?? "");
      formData.append("supplier_ids", supplier);
      formData.append("unit_id", newIngredientItem.base_unit.id);
      formData.append("default_unit_id", newIngredientItem.default_unit.id);
      formData.append("unit_code", newIngredientItem.base_unit.code);
      formData.append("base_qty", newIngredientItem.base_qty);
      formData.append("base_qty", newIngredientItem.base_qty);
      formData.append("default_qty", newIngredientItem.default_qty);
      formData.append("sort_order", newIngredientItem.sort_order);
      formData.append("group_id", newIngredientItem.itemGroup.id);
      formData.append("editSlug", newIngredientItem.editSlug);
      formData.append("status", (newIngredientItem.status == 1 || newIngredientItem.status  === true) ? 1 : 0);
      formData.append("allow_multi_quantity", (newIngredientItem.allow_multi_quantity));
      formData.append("is_non_purchasable", (newIngredientItem.is_non_purchasable == 1 || newIngredientItem.is_non_purchasable === true) ? 1 : 0);
      formData.append("price", newIngredientItem.price);
      formData.append("sell_price", newIngredientItem.sell_price || 0);
      formData.append("re_order_qty", newIngredientItem.reorderQty);
      formData.append("item_code", newIngredientItem.item_code === "" ? 0 : newIngredientItem.item_code);
      formData.append("inventory_account_id", newIngredientItem.coa_stock?.id ?? "");
      formData.append("inventory_account_name", newIngredientItem.coa_stock?.level3_name ?? "");
      formData.append("revenue_account_id", newIngredientItem.coa_revenue?.id ?? "");
      formData.append("revenue_account_name", newIngredientItem.coa_revenue?.level3_name ?? "");
      formData.append("cogs_account_id", newIngredientItem.coa_cogs?.id ?? "");
      formData.append("cogs_account_name", newIngredientItem.coa_cogs?.level3_name ?? "");

      try {
        const res = await axios.post(customerUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        setNewIngredientItem({
          id: null,
          name: "",
          brand_id: null,
          supplier:null,
          default_unit: null,
          base_unit : null,
          coa_cogs: null,
          coa_stock: null,
          coa_revenue: null,
          base_qty : 1,
          default_qty:"",
          sort_order: "",
          itemGroup: null,
          edit: false,
          status: true,
          allow_multi_quantity: 1,
          is_non_purchasable: false,
          editSlug: null,
          uploading: false,
          sell_price: 0,
        });
        setIngredientItemList(res.data[0]);
        setIngredientItemListForSearch(res.data[1])
        setIngredientItemStock(res.data[2])
        setIngredientItemForSearch(res.data[3]);
        setIngredientItemNonPurchase(res.data[4]);
        setSearchedIngredientGroup({
          ...searchedIngredientGroup,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Ingredient item has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      } catch (error) {
        setLoading(false);
        setNewIngredientItem({
          ...newIngredientItem,
          uploading: false,
        });
        if(error.response.data.status === 0){
          toast.error(`${_t(t(error.response.data.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        if(error.response.data.errors?.name){
          toast.error(`${_t(t(error.response.data.errors.name[0]))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      }
    }else {
      toast.error(`${_t(t("Please select a group"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //search customers here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedIngredientGroup({
        ...searchedIngredientGroup,
        searched: false,
      });
    } else {
      let searchedList = ingredientItemListForSearch.filter((item) => {
        //name
        let lowerCaseItemName = item.name.toLowerCase();
        //grp
        let lowerCaseItemGrp = item.group_name.toLowerCase();
        return (
          lowerCaseItemName.includes(searchInput) ||
          lowerCaseItemGrp.includes(searchInput)
        );
      });
      setSearchedIngredientGroup({
        ...searchedIngredientGroup,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal of waiter
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteIngredientGroup(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete customer here
  const handleDeleteIngredientGroup = (slug) => {
    setLoading(true);
    const customerUrl = BASE_URL + `/settings/delete-ingredient_item/${slug}`;
    return axios
      .get(customerUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setIngredientItemList(res.data[0]);
        setIngredientItemListForSearch(res.data[1])
        setIngredientItemStock(res.data[2])
        setIngredientItemForSearch(res.data[3]);
        setIngredientItemNonPurchase(res.data[4]);
        setSearchedIngredientGroup({
          ...searchedIngredientGroup,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(
          `${_t(t("Ingredient item has been deleted successfully"))}`,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const handleStatus = (e) => {
    setNewIngredientItem({
      ...newIngredientItem,
      status: !newIngredientItem.status
    })
  }

  const handleMultiQuantity = () =>{
    setNewIngredientItem({
      ...newIngredientItem,
      allow_multi_quantity: parseInt(newIngredientItem.allow_multi_quantity) === 0 ? 1 : 0,
    })
  }

  const handleNonPurchasable = () => {
    setNewIngredientItem({
      ...newIngredientItem,
      is_non_purchasable: !newIngredientItem.is_non_purchasable,
    });
  };

  const handleEmptyState = () =>{
    setNewIngredientItem({
      id:null,
      name: "",
      brand_id: null,
      supplier: null,
      default_unit: null,
      base_unit : null,
      coa_cogs: null,
      coa_stock: null,
      coa_revenue: null,
      base_qty : 1,
      default_qty : 0,
      sort_order: "",
      itemGroup: null,
      status: true,
      allow_multi_quantity: 1,
      is_non_purchasable: false,
      editSlug: null,
      price: 0,
      sell_price: 0,
      reorderQty: 0,
      item_code: "",
      edit: false,
      uploading: false,
    });
  }

  const handleItemCsv = () =>{
    setLoading(true);
    const url = BASE_URL + `/settings/get-food-ingredients-csv/item`;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        const formattedData = Array.isArray(res.data)
          ? res.data.map((item) => ({
              ...item,
              is_non_purchasable:
                item.is_non_purchasable !== undefined && item.is_non_purchasable !== null
                  ? item.is_non_purchasable
                  : 0,
            }))
          : res.data;
        csvExporter.generateCsv(formattedData);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  //upload csv
  function isCSV(contents) {
    // Basic check if it's a CSV file by checking if it contains a comma
    const rows = contents.split('\n');

    // Extract the header row (assuming it's the first row)
    const headerRow = rows[0];

    // Split the header row into individual header values
    const headers = headerRow.split(',');
    return contents.includes(',') && contents.includes('\n') && (headers.length >= 13);
  }
 
  const handleOnChange = (e) => {
    if (e.target.files[0]) {
      const fileReader = new FileReader();
      fileReader.readAsText(e.target.files[0]);
      //fileReader.readAsBinaryString(e.target.files[0]);
      fileReader.onload = (e) => {
        const contents = e.target.result;
        if(isCSV(contents)){
          const startIndex = 1; // Start index
          const lines = contents.trim().split('\n');
          const headerRow = lines[0];
          const headers = headerRow.split(',').map((h) => h.trim().replace(/["/\r\n]/g, ''));
          const nonPurchasableIdx = headers.indexOf('is_non_purchasable');

          const portion = lines.slice(startIndex);
          const parsedData = portion.map((line)=>{
            const values = line.split(',').map(value => value?.replace(/["/\r\n]/g, ''));
            if(!values[1] || !values[2] || !values[5] || !values[6]){
              toast.error(`Please Check item ${values[2] ? values[2] : "name"}, unit and unit_qty can't be empty`);
              if (document.getElementById('uploadFile')) {
                document.getElementById('uploadFile').value = '';
              }
              return false;
            }

            let isNonPurchasableVal = 0;
            if (nonPurchasableIdx !== -1 && values[nonPurchasableIdx] !== undefined) {
              isNonPurchasableVal = values[nonPurchasableIdx];
            } else if (values[14] !== undefined) {
              isNonPurchasableVal = values[14];
            } else if (values[13] !== undefined) {
              isNonPurchasableVal = values[13];
            }
              
            return {
              id : values[0],
              group_id: values[1],
              name : values[2],
              sort_order: values[3],
              item_code: values[4],
              unit: values[5],
              base_qty: values[6],
              default_unit_id: values[7],
              default_qty: values[8],
              price: values[9],
              sell_price: values[10],
              reorder_qty: values[11],
              status: values[12],
              // brands: values[13] ?? "",
              is_non_purchasable: isNonPurchasableVal,
            }
          });
          setUploadCsv(parsedData);
        }else {  
          if (document.getElementById('uploadFile')) {
            document.getElementById('uploadFile').value = '';
          }
          setUploadCsv(null)
          toast.error("Please upload only ingredient item csv file", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }); 
        } 
      };
   }; 
  }
  
  const handleCsvSubmit = (e) => {
    e.preventDefault();
    const url = BASE_URL +"/settings/upload-food-ingredient-unit-for-csv";
    let formData = {
      type:"item",
      items : uploadCsv
    }
    if(!uploadCsv || uploadCsv.length === 0){
      toast.error(`${_t(t("Please upload file"))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }
    setLoading(true);
    if (document.getElementById('uploadFile')) {
      document.getElementById('uploadFile').value = '';
    }
    return axios
      .post(url,formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setUploadCsv(null);
        setLoading(false);
        document.getElementById('item-btn').click();
        setIngredientItemList(res.data[0]);
        setIngredientItemListForSearch(res.data[1])
        setIngredientItemStock(res.data[2])
        setIngredientItemForSearch(res.data[3]);
        setIngredientItemNonPurchase(res.data[4]);
        setSearchedIngredientGroup({
          ...searchedIngredientGroup,
          list: res.data[1],
        });
        toast.success(`${_t(t("Item file upload successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        
      })
      .catch((err) => {
        setLoading(false);
        setUploadCsv(null);
        if(err.response.data?.status === 0){
          toast.error(`${_t(t(err.response.data.message))}`, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }); 
          return
        }
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  const handleFetchData = (page) => {
    setPaginatedIngredientItem(page);
  };

  const COLUMNS = [
    { label: "S/L", render: (item, i) => i + 1 + ((ingredientItemList?.current_page || 1) - 1) * (ingredientItemList?.per_page || 10) },
    { label: "Sort Order", render: (item) => item.sort_order },
    { label: "Name", render: (item) => item.name },
    { label: "Group", render: (item) => item.group_name },
    { label: "Total Qty", render: (item) => item?.Total_qty },
    { label: "Base Unit", render: (item) => item.unit },
    { label: "Base Qty", render: (item) => item.base_qty },
    { label: "Conv. Unit", render: (item) => item.default_unit_name },
    { label: "Conv. Qty", render: (item) => item.default_qty },
    {
      label: "Non Purchasable",
      render: (item) => (
        <span className="font-weight-bold">
          {item.is_non_purchasable == 1 || item.is_non_purchasable === true || item.is_non_purchasable === "1" ? (
            <span className="text-primary">YES</span>
          ) : (
            <span className="text-secondary">NO</span>
          )}
        </span>
      ),
    },
    { label: "Status", render: (item) => (
        <span className="font-weight-bold">
          {item.status === 1 ? <span className="text-primary">ON</span> : <span className="text-danger">OFF</span>}
        </span>
      )
    },
    {
      label: "Action",
      render: (item) => (
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-primary ml-2 rounded-sm del-btn"
            onClick={() => handleSetEdit(item.id)}
            data-toggle="modal"
            data-target="#addCustomer"
          >
            <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
          </button>
        </div>
      ),
    },
    { label: "Created By", render: (item) => item.created_by_name },
    { label: "Updated By", render: (item) => item.updated_by_name },
    {
      label: "Created At",
      render: (item) => item?.created_at ? <Moment format="LL">{item.created_at}</Moment> : "",
    },
    {
      label: "Updated At",
      render: (item) => item?.updated_at ? <Moment format="LL">{item.updated_at}</Moment> : "",
    },
  ];

  const getListData = () => {
    if (searchedIngredientGroup.searched) {
      return searchedIngredientGroup.list;
    }
    return ingredientItemList?.data || [];
  };

  const onClearSearch = () => {
    setSearchedIngredientGroup({ ...searchedIngredientGroup, searched: false });
    const searchInput = document.getElementById('itemSearchInput');
    if (searchInput) {
      searchInput.value = "";
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Ingredient Item"))}</title>
      </Helmet>

      {/*upload csv Modal*/}
      <div
        className="modal fade"
        id="csvImport"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content"></div>
              <button
                type="button"
                className="btn-close"
                id="item-btn"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  if (document.getElementById('uploadFile')) {
                    document.getElementById('uploadFile').value = '';
                  }
                  setUploadCsv(null)
                }}
              ></button>
            </div>
            <div className="modal-body">
            {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form 
                onSubmit={handleCsvSubmit} 
                autoComplete="off">
                  <div>
                    <label htmlFor="name" className="form-label">
                      {_t(t("Upload File"))}{" "}
                      <small style={{ color: "red" }}>*</small>
                    </label>
                    <br/>
                    <input
                      type={"file"}
                      id="uploadFile"
                      name="uploadFile"
                      accept={".csv"}
                      onChange={handleOnChange}
                    />
                  </div>
                  <button
                  disabled={loading}
                  type="submit"
                  className="btn btn-primary xsm-text text-uppercase px-3 py-2 my-4 rounded"
                  >
                    {_t(t("Submit"))}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add modal */}
      <div className="modal fade" id="addCustomer" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newIngredientItem.edit
                    ? _t(t("Add new Ingredient Item"))
                    : _t(t("Update Ingredient Item"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newIngredientItem.uploading === false ? (
                <div key="fragment-customer-1">
                  <form
                    onSubmit={
                      !newIngredientItem.edit
                        ? handleSaveNewIngredientGroup
                        : handleUpdateIngredientGroup
                    }
                    autoComplete="off"
                  >
                    <div className="row">
                    {ingredientGroupForSearch && (
                      <div className="form-group col-6">
                        <div className="mb-2">
                          <label htmlFor="itemGroup" className="control-label">
                            {_t(t("Ingredient group"))}
                            <span className="text-danger">*</span>
                          </label>
                        </div>

                        <Select
                          options={ingredientGroupForSearch}
                          components={makeAnimated()}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          classNamePrefix="select"
                          onChange={handleSetItemGroup}
                          value={newIngredientItem.itemGroup}
                          maxMenuHeight="200px"
                          placeholder={
                            _t(t("Please select an Ingredient group")) + ".."
                          }
                        />
                      </div>
                    )}
                      <div className="form-group col-6">
                        <div className="mb-2">
                          <label htmlFor="brand" className="control-label">
                            {_t(t("Brand"))}
                          </label>
                        </div>

                        <Select
                          options={brandStatus ?? []}
                          components={makeAnimated()}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          classNamePrefix="select"
                          onChange={handleSetItemBrand}
                          value={newIngredientItem.brand}
                          maxMenuHeight="200px"
                          isClearable
                          placeholder={
                            _t(t("Please select brand")) + ".."
                          }
                        />
                      </div>
                    </div>

                    <div className="row"> 
                      <div className="mt-3 col-4">
                        <label htmlFor="name" className="form-label">
                          {_t(t("Name"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="chicken"
                          value={newIngredientItem.name || ""}
                          required
                          onChange={handleSetNewIngredientGroup}
                        />
                      </div>

                      <div className="mt-3 col-4">
                        <label htmlFor="item_code" className="form-label">
                          {_t(t("Item Code"))}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="item_code"
                          name="item_code"
                          placeholder="c102"
                          value={newIngredientItem.item_code || ""}
                          onChange={handleSetNewIngredientGroup}
                        />
                      </div>

                      <div className="mt-3 col-4">
                        <label htmlFor="sell_price" className="form-label">
                          {_t(t("Sale Rate"))}
                        </label>
                        <input
                          type="number"
                          step={0.01}
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}  
                          min="0"
                          className="form-control"
                          id="sell_price"
                          name="sell_price"
                          placeholder="0"
                          value={newIngredientItem.sell_price || ""}
                          onChange={handleSetNewIngredientGroup}
                        />
                      </div>
                    </div>
                  
                    <div className="row">

                      <div className="mt-3 col-4">
                      <label htmlFor="default_unit" className="form-label">
                        {_t(t("Purchase Unit"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                        <Select
                          options={filteredIngUnits}
                          value={newIngredientItem.default_unit}
                          components={makeAnimated()}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.name}
                          classNamePrefix="select"
                          onChange={handleSetIngredientUnit}
                          maxMenuHeight="200px"
                          placeholder={
                            _t(t("Please select unit")) + ".."
                          }
                        />
                      </div>
                      <div className="mt-3 col-2">
                      <label htmlFor="default_qty" className="form-label">
                        {_t(t("Conver. Qty"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="number"
                        step={0.1}
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                          evt.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}  
                        min="0"
                        className="form-control"
                        id="default_qty"
                        name="default_qty"
                        placeholder="0"
                        value={newIngredientItem.default_qty}
                        required
                        onChange={handleSetNewIngredientGroup}
                      />
                      </div>

                      <div className="mt-3 col-4">
                      <label htmlFor="base_unit" className="form-label">
                        {_t(t("Consumption Unit"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                        <Select
                          options={filteredIngUnits}
                          value={newIngredientItem.base_unit}
                          components={makeAnimated()}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.name}
                          classNamePrefix="select"
                          onChange={handleSetIngredientBaseUnit}
                          maxMenuHeight="200px"
                          placeholder={
                            _t(t("Please select unit")) + ".."
                          }
                        />
                      </div>
                      <div className="mt-3 col-2">
                      <label htmlFor="base_qty" className="form-label">
                        {_t(t("Consmp. Qty"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                          evt.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}  
                        min="0"
                        id="base_qty"
                        name="base_qty"
                        placeholder="0"
                        value={newIngredientItem.base_qty || ""}
                        required
                        onChange={handleSetNewIngredientGroup}
                      />
                      </div>
                    
                    </div>
      
                    <div className="row">
                      <div className="mt-3 col-5">
                      <label htmlFor="price" className="form-label">
                        {_t(t("Price"))}
                      </label>
                      <input
                        type="number"
                        step={0.01}
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                          evt.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}  
                        min="0"
                        className="form-control"
                        id="price"
                        name="price"
                        placeholder="0"
                        value={newIngredientItem.price}
                        onChange={handleSetNewIngredientGroup}
                      />
                      </div>
                      <div className="mt-3 col-5">
                        <label htmlFor="reorderQty" className="form-label">
                          {_t(t("Re-Order Quantity"))}
                        </label>
                        <input
                          type="number"
                          step={0.1}
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}  
                          min="0"
                          className="form-control"
                          id="reorderQty"
                          name="reorderQty"
                          placeholder="0"
                          value={newIngredientItem.reorderQty}
                          onChange={handleSetNewIngredientGroup}
                        />
                      </div>
                       <div className="mt-3 col-2">
                        <label htmlFor="sort_order" className="form-label">
                          {_t(t("Sort Order"))}
                        </label>
                        <input
                          type="number"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}  
                          min="0"
                          className="form-control"
                          id="sort_order"
                          name="sort_order"
                          placeholder="0"
                          value={newIngredientItem.sort_order}
                          onChange={handleSetNewIngredientGroup}
                        />
                      </div>
                    </div>

                    <div className="row ml-0">
                      <div className="form-check mt-4 col-4">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="has_multiple_quantity"
                          checked={newIngredientItem.allow_multi_quantity}
                          onChange={handleMultiQuantity}
                        />
                        <label
                          className="form-check-label pointer-cursor"
                          htmlFor="has_multiple_quantity"
                        >
                          {_t(t("Allow multiple quantity?"))}
                        </label>
                      </div>

                      <div className="form-check mt-4 col-4">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="is_non_purchasable"
                          checked={Boolean(newIngredientItem.is_non_purchasable)}
                          onChange={handleNonPurchasable}
                        />
                        <label
                          className="form-check-label pointer-cursor"
                          htmlFor="is_non_purchasable"
                        >
                          {_t(t("Non Purchasable?"))}
                        </label>
                      </div>

                      <div className="form-check mt-4 col-4 pl-3">
                        <Switch
                            checked={newIngredientItem.status}
                            name="status"
                            onChange={(e) => {
                              handleStatus(e);
                            }}
                            height={22}
                            width={44}
                            offColor="#ee5253"
                            className="float-left"
                        />
                        <label
                          className="form-check-label pointer-cursor ml-2"
                          htmlFor="status"
                        >
                          {_t(t("Status"))}
                        </label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="mt-2 col-4">
                        <label htmlFor="_unit" className="form-label mb-1">
                          {_t(t("COA (stock)"))}{" "}
                        </label>
                        <Select
                          options={cao3Active ?? []}
                          value={newIngredientItem.coa_stock}
                          getOptionLabel={(option) => option.level3_name}
                          getOptionValue={(option) => option.id}
                          classNamePrefix="select"
                          isClearable
                          onChange={(coa_stock) => handleSetSelect("coa_stock", coa_stock)}
                          maxMenuHeight="200px"
                          placeholder={
                            _t(t("Please select coa")) + ".."
                          }
                        />
                      </div>
                      <div className="mt-2 col-4">
                        <label htmlFor="_unit" className="form-label mb-1">
                          {_t(t("COA (revenue)"))}{" "}
                        </label>
                        <Select
                          options={cao3Active ?? []}
                          value={newIngredientItem.coa_revenue}
                          getOptionLabel={(option) => option.level3_name}
                          getOptionValue={(option) => option.id}
                          classNamePrefix="select"
                          isClearable
                          onChange={(coa_revenue) => handleSetSelect("coa_revenue", coa_revenue)}
                          maxMenuHeight="200px"
                          placeholder={
                            _t(t("Please select coa")) + ".."
                          }
                        />
                      </div>
                      <div className="mt-2 col-4">
                        <label htmlFor="_unit" className="form-label mb-1">
                          {_t(t("COA (cogs)"))}{" "}
                        </label>
                        <Select
                          options={cao3Active ?? []}
                          value={newIngredientItem.coa_cogs}
                          getOptionLabel={(option) => option.level3_name}
                          getOptionValue={(option) => option.id}
                          classNamePrefix="select"
                          isClearable
                          onChange={(coa_cogs) => handleSetSelect("coa_cogs", coa_cogs)}
                          maxMenuHeight="200px"
                          placeholder={
                            _t(t("Please select coa")) + ".."
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group mt-4">
                      <div className="mb-2">
                        <label
                          htmlFor="branch"
                          className="control-label"
                        >
                          {_t(t("Supplier"))}
                        </label>
                      </div>
                      <Select
                        options={supplierForSearch || []}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        value={newIngredientItem.supplier || ""}
                        isClearable
                        isMulti
                        classNamePrefix="select"
                        onChange={handleSetSupplier}
                        maxMenuHeight="200px"
                        placeholder={
                          _t(t("Please select a supplier")) + ".."
                        }
                      />
                    </div>

                    <div className="mt-4">
                      <div className="row d-flex justify-content-end align-items-center">
                        <div className="col-3">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newIngredientItem.edit
                              ? _t(t("Save"))
                              : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end align-items-center">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newIngredientItem.edit
                            ? _t(t("Save"))
                            : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              {/* Loading effect */}
              {/* {newIngredientItem.uploading === true ||
              loading === true ? (
                tableLoading()
              ) : ( */}
              <div key="fragment3" className="t-bg-white">
                {/* next page data spin loading */}
                {/* <CustomSpinLoader loading={loading || dataPaginating}/> */}
                {/* spin loading ends */}

                <div className="row mx-2 gx-2 align-items-center t-pt-15 t-pb-15">
                  <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                    <ul className="t-list fk-breadcrumb d-flex justify-content-between align-items-center">
                      <li className="fk-breadcrumb__list">
                        <span className="t-link fk-breadcrumb__link text-capitalize">
                          {!searchedIngredientGroup.searched
                            ? _t(t("Ingredient Item"))
                            : _t(t("Search Result"))}
                        </span>
                      </li>
                      <div>
                        <button title="Download food items in excel" className="btn btn-success btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>handleItemCsv()} >Export Csv</button>
                        <button title="Upload food items in excel" className="btn btn-primary btn-sm text-uppercase sm-text mr-2 rounded" data-toggle="modal" data-target="#csvImport">Import Csv</button>
                      </div>
                    </ul>
                  </div>
                  <div className="col-md-6 col-lg-7">
                    <div className="row gx-3 align-items-center">
                      {/* Search customer */}
                      <div className="col-md-9 t-mb-15 mb-md-0">
                        <div className="input-group">
                          <div className="form-file">
                            <input
                              type="text"
                              id="itemSearchInput"
                              className="form-control border-0 form-control--light-1 rounded-left"
                              placeholder={_t(t("Search")) + ".."}
                              onChange={handleSearch}
                            />
                          </div>
                          <button
                            className="btn btn-primary rounded-right"
                            type="button"
                          >
                            <i
                              className="fa fa-search"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </div>

                      {/* Add customer modal trigger button */}
                      <div className="col-md-3 text-md-right">
                        <button
                          type="button"
                          className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                          data-toggle="modal"
                          data-target="#addCustomer"
                          onClick={() => {
                            handleEmptyState()
                          }}
                        >
                          {_t(t("add new"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <DataTable
                  loading={loading}
                  data={getListData()}
                  columns={COLUMNS}
                  emptyText="No data available"
                  pagination={{
                    isPageLoading: loading,
                    isPagination: true,
                    pageCount: ingredientItemList?.last_page,
                    currentPage: ingredientItemList?.current_page,
                    from: ingredientItemList?.from,
                    to: ingredientItemList?.to,
                    total: ingredientItemList?.total,
                  }}
                  handleFetchData={handleFetchData}
                  searchPayload={{
                    isSearched: searchedIngredientGroup.searched,
                    onClearSearch,
                  }}
                />
              </div>                    
            </div>
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default IngredientItem;
